import {UUID} from '../../../shared/types/uuid.type';
import { createAction, props } from '@ngrx/store';

const prefix = '[DeleteManyClips] ';

export const deleteManyClips = createAction(
  `${prefix} Delete Many Clips`,
  props<{ ids: UUID[] }>()
);

export const deleteManyClipsSuccess = createAction(
  `${prefix} Delete Many Clips Success`,
  props<{ ids: UUID[] }>()
);

export const deleteManyClipsFailure = createAction(
  `${prefix} Delete Many Clips Failure`,
  props<{ error: any }>()
);

export const clearDeleteManyClipsState = createAction(
  `${prefix} Clear Delete Many Clips State`,
);
